import { amenityDisplay } from '../composables/useRoomAmenities'

export type RoomAmenityGroup =
	| 'Conectividad y trabajo'
	| 'Confort y equipamiento'
	| 'Accesibilidad'
	| 'Entretenimiento'
	| 'Cargos y condiciones'
	| 'Otros detalles'

export interface RoomAmenityDetail {
	code: string
	label: string
	icon: string
	group: RoomAmenityGroup
	priority: number
}

const groupOrder: RoomAmenityGroup[] = [
	'Confort y equipamiento',
	'Conectividad y trabajo',
	'Accesibilidad',
	'Entretenimiento',
	'Cargos y condiciones',
	'Otros detalles',
]

function groupFor(label: string): RoomAmenityGroup {
	const name = label.toLocaleLowerCase('es-MX')
	if (/cargo|depósito|cuota|tarifa adicional/.test(name)) return 'Cargos y condiciones'
	if (/accesib|discapacidad|silla de ruedas|auditiv|braille/.test(name)) return 'Accesibilidad'
	if (/internet|wi-?fi|escritorio|computadora|enchufe/.test(name)) return 'Conectividad y trabajo'
	if (/televisión|película|video|radio|canal de noticias/.test(name)) return 'Entretenimiento'
	if (/aire acondicionado|cama|almohada|baño|tina|regadera|cafetera|refrigerador|balcón|terraza|desayuno|sofá|ropa de cama/.test(name)) {
		return 'Confort y equipamiento'
	}
	return 'Otros detalles'
}

function priorityFor(label: string, group: RoomAmenityGroup): number {
	const name = label.toLocaleLowerCase('es-MX')
	if (group === 'Cargos y condiciones') return 90
	if (/desayuno.*incluido/.test(name)) return 0
	if (/internet.*gratuito|wi-?fi.*gratuito/.test(name)) return 1
	if (/habitación accesible|baño accesible|silla de ruedas/.test(name)) return 2
	if (/aire acondicionado/.test(name)) return 3
	if (/wi-?fi|internet/.test(name)) return 4
	if (/refrigerador|cafetera|escritorio/.test(name)) return 5
	if (/balcón|terraza|tina|regadera/.test(name)) return 6
	if (/teléfono/.test(name)) return 60
	if (group === 'Confort y equipamiento') return 20
	if (group === 'Conectividad y trabajo') return 25
	if (group === 'Accesibilidad') return 30
	if (group === 'Entretenimiento') return 50
	return 70
}

export function roomAmenityDetails(amenities: Array<string | number> = []): RoomAmenityDetail[] {
	const seen = new Set<string>()
	return amenities.flatMap((amenity) => {
		const code = String(amenity)
		const { label, icon } = amenityDisplay(amenity)
		if (!label || (/^\d+$/.test(code) && label === code)) return []
		const key = label.trim().toLocaleLowerCase('es-MX')
		if (seen.has(key)) return []
		seen.add(key)
		const group = groupFor(label)
		return [{ code, label, icon, group, priority: priorityFor(label, group) }]
	})
}

export function roomAmenityGroups(amenities: Array<string | number> = []) {
	const details = roomAmenityDetails(amenities)
	return groupOrder
		.map((name) => ({
			name,
			items: details.filter((item) => item.group === name),
		}))
		.filter((group) => group.items.length > 0)
}
